import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Observable } from 'rxjs';
import { BaseApi } from 'src/backend/api/base-api';

@Injectable({
  providedIn: 'root'
})
export class ChatbotConfigService {

  constructor(private http: HttpClient,private baseApi: BaseApi) { }

  private userCode: string | null = null;

  setUserCode(userCode: string): void {
    this.userCode = userCode;
  }

  getUserCode(): string | null {
    return this.userCode;
  }

  createEditChatbotConfigurations(data: any): Observable<any> {
    return this.http.post<any>(this.baseApi.encodeURL(Constants.API_CHATBOT_CONFIGURATIONS_CREATE_EDIT), data);
  }

  getUserChatbotConfiguration(key: any): Observable<any> {
    return this.http.post<any>(this.baseApi.encodeURL(Constants.API_CHATBOT_CONFIGURATIONS_GET), key);
  }
  
}
